// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300;400;500;600;700&family=Outfit:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
        --background: 0 0% 100%;
        --foreground: 230 67% 19%;
        --card: 0 0% 100%;
        --card-foreground: 230 67% 19%;
        --popover: 0 0% 100%;
        --popover-foreground: 230 67% 19%;
        --primary: 232 86% 29%;
        --primary-foreground: 0 0% 100%;
        --secondary: 209 30% 90%;
        --secondary-foreground: 230 67% 19%;
        --muted: 210 40% 96%;
        --muted-foreground: 215 20% 45%;
        --accent: 0 75% 48%;
        --accent-foreground: 0 0% 100%;
        --destructive: 0 75% 48%;
        --destructive-foreground: 0 0% 100%;
        --border: 214 32% 91%;
        --input: 214 32% 91%;
        --ring: 232 86% 29%;
        --chart-1: 232 86% 29%;
        --chart-2: 209 30% 65%;
        --chart-3: 0 75% 48%;
        --chart-4: 230 67% 19%;
        --chart-5: 209 30% 85%;
        --radius: 0.85rem;
    }

*{
  border-color: hsl(var(--border));
}

body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}

h1,h2,h3,h4,h5 { font-family: "Hind Siliguri", "Outfit", sans-serif; }

.font-display { font-family: "Outfit", "Hind Siliguri", sans-serif; letter-spacing: -0.02em; }
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-10{
  left: -2.5rem;
}
.-left-12{
  left: -3rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-1\\.5{
  right: -0.375rem;
}
.-right-12{
  right: -3rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-10{
  top: -2.5rem;
}
.-top-12{
  top: -3rem;
}
.-top-6{
  top: -1.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-\\[10\\%\\]{
  bottom: 10%;
}
.bottom-\\[15\\%\\]{
  bottom: 15%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-\\[5\\%\\]{
  left: 5%;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.left-\\[6\\%\\]{
  left: 6%;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-3\\.5{
  right: 0.875rem;
}
.right-4{
  right: 1rem;
}
.right-\\[10\\%\\]{
  right: 10%;
}
.right-\\[5\\%\\]{
  right: 5%;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-32{
  top: 8rem;
}
.top-4{
  top: 1rem;
}
.top-\\[10\\%\\]{
  top: 10%;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[5\\%\\]{
  top: 5%;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-\\[8\\%\\]{
  top: 8%;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[999\\]{
  z-index: 999;
}
.z-\\[110\\]{
  z-index: 110;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-\\[20px\\]{
  margin-left: 20px;
}
.ml-auto{
  margin-left: auto;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-\\[15px\\]{
  margin-right: 15px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-\\[16\\/7\\]{
  aspect-ratio: 16/7;
}
.aspect-\\[3\\/4\\]{
  aspect-ratio: 3/4;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[65vh\\]{
  height: 65vh;
}
.h-\\[75vh\\]{
  height: 75vh;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[65vh\\]{
  max-height: 65vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1{
  width: 0.25rem;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[95vw\\]{
  width: 95vw;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[32px\\]{
  min-width: 32px;
}
.min-w-\\[400px\\]{
  min-width: 400px;
}
.min-w-\\[500px\\]{
  min-width: 500px;
}
.min-w-\\[600px\\]{
  min-width: 600px;
}
.min-w-\\[60px\\]{
  min-width: 60px;
}
.min-w-\\[800px\\]{
  min-width: 800px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[90px\\]{
  max-width: 90px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.snap-x{
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-start{
  scroll-snap-align: start;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.scroll-smooth{
  scroll-behavior: smooth;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[32px\\]{
  border-radius: 32px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#0B1E8A\\]{
  --tw-border-opacity: 1;
  border-color: rgb(11 30 138 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0B1E8A\\]\\/20{
  border-color: rgb(11 30 138 / 0.2);
}
.border-\\[\\#0B1E8A\\]\\/30{
  border-color: rgb(11 30 138 / 0.3);
}
.border-\\[\\#D1DFF0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(209 223 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D61F1F\\]{
  --tw-border-opacity: 1;
  border-color: rgb(214 31 31 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D61F1F\\]\\/30{
  border-color: rgb(214 31 31 / 0.3);
}
.border-\\[\\#E2EAF4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(226 234 244 / var(--tw-border-opacity, 1));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-brand-light{
  --tw-border-opacity: 1;
  border-color: rgb(220 231 241 / var(--tw-border-opacity, 1));
}
.border-brand-light\\/60{
  border-color: rgb(220 231 241 / 0.6);
}
.border-brand-navy\\/30{
  border-color: rgb(8 20 90 / 0.3);
}
.border-brand-red{
  --tw-border-opacity: 1;
  border-color: rgb(214 31 31 / var(--tw-border-opacity, 1));
}
.border-brand-royal{
  --tw-border-opacity: 1;
  border-color: rgb(11 30 138 / var(--tw-border-opacity, 1));
}
.border-brand-royal\\/20{
  border-color: rgb(11 30 138 / 0.2);
}
.border-brand-royal\\/40{
  border-color: rgb(11 30 138 / 0.4);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.border-pink-200{
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-pink-300{
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity, 1));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-300{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-\\[\\#0B1E8A\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(11 30 138 / var(--tw-border-opacity, 1));
}
.border-t-brand-royal{
  --tw-border-opacity: 1;
  border-top-color: rgb(11 30 138 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#08145A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(8 20 90 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B1E8A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 30 138 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D61F1F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 31 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E2EAF4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 234 244 / var(--tw-bg-opacity, 1));
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/95{
  background-color: rgb(0 0 0 / 0.95);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-brand-light{
  --tw-bg-opacity: 1;
  background-color: rgb(220 231 241 / var(--tw-bg-opacity, 1));
}
.bg-brand-light\\/20{
  background-color: rgb(220 231 241 / 0.2);
}
.bg-brand-light\\/30{
  background-color: rgb(220 231 241 / 0.3);
}
.bg-brand-light\\/40{
  background-color: rgb(220 231 241 / 0.4);
}
.bg-brand-light\\/50{
  background-color: rgb(220 231 241 / 0.5);
}
.bg-brand-navy{
  --tw-bg-opacity: 1;
  background-color: rgb(8 20 90 / var(--tw-bg-opacity, 1));
}
.bg-brand-red{
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 31 / var(--tw-bg-opacity, 1));
}
.bg-brand-red\\/10{
  background-color: rgb(214 31 31 / 0.1);
}
.bg-brand-royal{
  --tw-bg-opacity: 1;
  background-color: rgb(11 30 138 / var(--tw-bg-opacity, 1));
}
.bg-brand-royal\\/10{
  background-color: rgb(11 30 138 / 0.1);
}
.bg-brand-royal\\/30{
  background-color: rgb(11 30 138 / 0.3);
}
.bg-brand-royal\\/5{
  background-color: rgb(11 30 138 / 0.05);
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/40{
  background-color: rgb(254 242 242 / 0.4);
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85{
  background-color: rgb(255 255 255 / 0.85);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-\\[\\#08145A\\]{
  --tw-gradient-from: #08145A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 20 90 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0B1E8A\\]{
  --tw-gradient-from: #0B1E8A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(11 30 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#DCE7F1\\]{
  --tw-gradient-from: #DCE7F1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 231 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brand-light\\/40{
  --tw-gradient-from: rgb(220 231 241 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 231 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brand-light\\/60{
  --tw-gradient-from: rgb(220 231 241 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 231 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brand-royal{
  --tw-gradient-from: #0B1E8A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(11 30 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50{
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#0B1E8A\\]{
  --tw-gradient-to: rgb(11 30 138 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0B1E8A var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-brand-royal{
  --tw-gradient-to: rgb(11 30 138 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0B1E8A var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#08145A\\]{
  --tw-gradient-to: #08145A var(--tw-gradient-to-position);
}
.to-\\[\\#0B1E8A\\]{
  --tw-gradient-to: #0B1E8A var(--tw-gradient-to-position);
}
.to-\\[\\#1e40af\\]{
  --tw-gradient-to: #1e40af var(--tw-gradient-to-position);
}
.to-\\[\\#AFC4D6\\]\\/40{
  --tw-gradient-to: rgb(175 196 214 / 0.4) var(--tw-gradient-to-position);
}
.to-brand-light\\/20{
  --tw-gradient-to: rgb(220 231 241 / 0.2) var(--tw-gradient-to-position);
}
.to-brand-navy{
  --tw-gradient-to: #08145A var(--tw-gradient-to-position);
}
.to-slate-200{
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-fill{
  object-fit: fill;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-11{
  padding-right: 2.75rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-bn{
  font-family: "Hind Siliguri", sans-serif;
}
.font-en{
  font-family: "Outfit", sans-serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[100px\\]{
  font-size: 100px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[120px\\]{
  font-size: 120px;
}
.text-\\[140px\\]{
  font-size: 140px;
}
.text-\\[180px\\]{
  font-size: 180px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.italic{
  font-style: italic;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#08145A\\]{
  --tw-text-opacity: 1;
  color: rgb(8 20 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0B1E8A\\]{
  --tw-text-opacity: 1;
  color: rgb(11 30 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#AFC4D6\\]{
  --tw-text-opacity: 1;
  color: rgb(175 196 214 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D61F1F\\]{
  --tw-text-opacity: 1;
  color: rgb(214 31 31 / var(--tw-text-opacity, 1));
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-brand-navy{
  --tw-text-opacity: 1;
  color: rgb(8 20 90 / var(--tw-text-opacity, 1));
}
.text-brand-navy\\/30{
  color: rgb(8 20 90 / 0.3);
}
.text-brand-navy\\/40{
  color: rgb(8 20 90 / 0.4);
}
.text-brand-navy\\/50{
  color: rgb(8 20 90 / 0.5);
}
.text-brand-navy\\/55{
  color: rgb(8 20 90 / 0.55);
}
.text-brand-navy\\/60{
  color: rgb(8 20 90 / 0.6);
}
.text-brand-navy\\/65{
  color: rgb(8 20 90 / 0.65);
}
.text-brand-navy\\/70{
  color: rgb(8 20 90 / 0.7);
}
.text-brand-navy\\/75{
  color: rgb(8 20 90 / 0.75);
}
.text-brand-navy\\/80{
  color: rgb(8 20 90 / 0.8);
}
.text-brand-navy\\/85{
  color: rgb(8 20 90 / 0.85);
}
.text-brand-red{
  --tw-text-opacity: 1;
  color: rgb(214 31 31 / var(--tw-text-opacity, 1));
}
.text-brand-royal{
  --tw-text-opacity: 1;
  color: rgb(11 30 138 / var(--tw-text-opacity, 1));
}
.text-brand-royal\\/30{
  color: rgb(11 30 138 / 0.3);
}
.text-brand-royal\\/40{
  color: rgb(11 30 138 / 0.4);
}
.text-brand-royal\\/50{
  color: rgb(11 30 138 / 0.5);
}
.text-brand-royal\\/60{
  color: rgb(11 30 138 / 0.6);
}
.text-brand-royal\\/80{
  color: rgb(11 30 138 / 0.8);
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/55{
  color: rgb(255 255 255 / 0.55);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/65{
  color: rgb(255 255 255 / 0.65);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.placeholder-slate-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#0B1E8A\\]{
  accent-color: #0B1E8A;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 4px 12px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-brand-royal{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(11 30 138 / var(--tw-ring-opacity, 1));
}
.ring-brand-royal\\/30{
  --tw-ring-color: rgb(11 30 138 / 0.3);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

html { scroll-behavior: smooth; }

body {
    margin: 0;
    font-family: "Hind Siliguri", "Outfit", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #ffffff;
    color: #08145A;
}

/* ===== Custom utilities ===== */
.glass {
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.6);
    box-shadow: 0 8px 32px rgba(11, 30, 138, 0.06);
}
.glass-dark {
    background: rgba(8, 20, 90, 0.72);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.08);
}
.bg-hero-grad {
    background:
        radial-gradient(circle at 8% 18%, rgba(220, 231, 241, 0.9), transparent 55%),
        radial-gradient(circle at 92% 12%, rgba(175, 196, 214, 0.55), transparent 55%),
        radial-gradient(circle at 50% 90%, rgba(11, 30, 138, 0.12), transparent 60%),
        linear-gradient(135deg, #ffffff 0%, #DCE7F1 100%);
}
.shadow-soft { box-shadow: 0 4px 20px rgba(11, 30, 138, 0.08); }
.shadow-pop { box-shadow: 0 18px 50px -12px rgba(11, 30, 138, 0.28); }
.gradient-text-blue {
    background: linear-gradient(135deg, #0B1E8A 0%, #08145A 50%, #0B1E8A 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}
.btn-primary {
    background: linear-gradient(135deg, #0B1E8A 0%, #08145A 100%);
    color: #fff;
    transition: all 0.3s ease;
}
.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 32px -10px rgba(11, 30, 138, 0.55);
}
.btn-accent {
    background: linear-gradient(135deg, #D61F1F 0%, #A41616 100%);
    color: #fff;
}
.btn-accent:hover { transform: translateY(-2px); box-shadow: 0 14px 30px -10px rgba(214, 31, 31, 0.55); }

.book-card {
    transition: transform 0.4s cubic-bezier(.21,.61,.35,1), box-shadow 0.4s ease;
}
.book-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 24px 48px -16px rgba(11, 30, 138, 0.25);
}

/* Math symbols floating background */
.math-symbol {
    position: absolute;
    color: rgba(11, 30, 138, 0.06);
    font-family: "Outfit", serif;
    font-weight: 700;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
}

/* hero curved separator */
.curve-bottom {
    position: absolute;
    bottom: -1px; left: 0; right: 0;
    width: 100%;
    height: 80px;
}

/* Marquee track */
.marquee {
    display: flex;
    overflow: hidden;
    mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);
}
.marquee-track {
    display: flex;
    flex-shrink: 0;
    gap: 3rem;
    animation: marquee-x 35s linear infinite;
}

/* Sidebar for admin */
.admin-shell { background: #F1F5F9; }
.admin-side {
    background: linear-gradient(180deg, #08145A 0%, #0B1E8A 100%);
    color: #fff;
}
.admin-side a.active, .admin-side button.active {
    background: rgba(255, 255, 255, 0.15);
    border-left: 3px solid #D61F1F;
}

/* ===== React Quill (admin editor) overrides ===== */
.rich-editor .ql-toolbar {
    border-color: #E2E8F0 !important;
    background: #F8FAFC;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
.rich-editor .ql-container {
    border-color: #E2E8F0 !important;
    min-height: 140px;
    font-family: "Hind Siliguri", "Outfit", sans-serif;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
}
.rich-editor .ql-editor { min-height: 140px; }

/* ===== Prose styling for rendered HTML on book details ===== */
.prose h1, .prose h2, .prose h3 { color: #08145A; font-weight: 700; margin-top: 1em; margin-bottom: 0.5em; }
.prose h1 { font-size: 1.5em; }
.prose h2 { font-size: 1.25em; }
.prose h3 { font-size: 1.1em; }
.prose p { margin: 0.5em 0; line-height: 1.7; }
.prose ul, .prose ol { padding-left: 1.5em; margin: 0.5em 0; }
.prose ul { list-style-type: disc; }
.prose ol { list-style-type: decimal; }
.prose li { margin: 0.2em 0; }
.prose strong { color: #08145A; }
.prose em { color: #0B1E8A; }
.prose blockquote { border-left: 3px solid #0B1E8A; padding-left: 1em; color: #475569; font-style: italic; margin: 0.75em 0; }
.prose a { color: #0B1E8A; text-decoration: underline; }
.prose code, .prose pre { background: #F1F5F9; padding: 0.15em 0.4em; border-radius: 4px; font-size: 0.9em; }
.prose table { width: 100%; border-collapse: collapse; }
.prose td, .prose th { border: 1px solid #E2E8F0; padding: 0.5em; }

/* Quill toolbar inside Shadcn Dialog needs higher z-index */
.ql-tooltip { z-index: 60 !important; }
.ql-picker-options { z-index: 60 !important; }

/* ===== Custom scrollbar ===== */
::-webkit-scrollbar { width: 4px; height: 4px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #CBD5E1; border-radius: 999px; }
::-webkit-scrollbar-thumb:hover { background: #94A3B8; }
* { scrollbar-width: thin; scrollbar-color: #CBD5E1 transparent; }

[data-debug-wrapper="true"] { display: contents !important; }
[data-debug-wrapper="true"] > * {
    margin-left: inherit; margin-right: inherit; margin-top: inherit; margin-bottom: inherit;
    padding-left: inherit; padding-right: inherit; padding-top: inherit; padding-bottom: inherit;
    column-gap: inherit; row-gap: inherit; gap: inherit;
    border-left-width: inherit; border-right-width: inherit; border-top-width: inherit; border-bottom-width: inherit;
    border-left-style: inherit; border-right-style: inherit; border-top-style: inherit; border-bottom-style: inherit;
    border-left-color: inherit; border-right-color: inherit; border-top-color: inherit; border-bottom-color: inherit;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-brand-royal:hover{
  --tw-border-opacity: 1;
  border-color: rgb(11 30 138 / var(--tw-border-opacity, 1));
}
.hover\\:border-brand-royal\\/40:hover{
  border-color: rgb(11 30 138 / 0.4);
}
.hover\\:border-brand-royal\\/50:hover{
  border-color: rgb(11 30 138 / 0.5);
}
.hover\\:bg-\\[\\#0B1B75\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(11 27 117 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#0B1E8A\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(11 30 138 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-light\\/15:hover{
  background-color: rgb(220 231 241 / 0.15);
}
.hover\\:bg-brand-light\\/20:hover{
  background-color: rgb(220 231 241 / 0.2);
}
.hover\\:bg-brand-light\\/30:hover{
  background-color: rgb(220 231 241 / 0.3);
}
.hover\\:bg-brand-light\\/40:hover{
  background-color: rgb(220 231 241 / 0.4);
}
.hover\\:bg-brand-light\\/50:hover{
  background-color: rgb(220 231 241 / 0.5);
}
.hover\\:bg-brand-navy:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(8 20 90 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-red:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 31 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-red\\/10:hover{
  background-color: rgb(214 31 31 / 0.1);
}
.hover\\:bg-brand-royal\\/20:hover{
  background-color: rgb(11 30 138 / 0.2);
}
.hover\\:bg-brand-royal\\/90:hover{
  background-color: rgb(11 30 138 / 0.9);
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50\\/50:hover{
  background-color: rgb(248 250 252 / 0.5);
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:text-\\[\\#0B1E8A\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(11 30 138 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#AFC4D6\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(175 196 214 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#D61F1F\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(214 31 31 / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-brand-navy:hover{
  --tw-text-opacity: 1;
  color: rgb(8 20 90 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-red:hover{
  --tw-text-opacity: 1;
  color: rgb(214 31 31 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-royal:hover{
  --tw-text-opacity: 1;
  color: rgb(11 30 138 / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-\\[\\#0B1E8A\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(11 30 138 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#D61F1F\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(214 31 31 / var(--tw-border-opacity, 1));
}
.focus\\:border-brand-royal:focus{
  --tw-border-opacity: 1;
  border-color: rgb(11 30 138 / var(--tw-border-opacity, 1));
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#0B1E8A\\]\\/30:focus{
  --tw-ring-color: rgb(11 30 138 / 0.3);
}
.focus\\:ring-\\[\\#D61F1F\\]\\/30:focus{
  --tw-ring-color: rgb(214 31 31 / 0.3);
}
.focus\\:ring-blue-800:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 64 175 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-brand-royal\\/30:focus{
  --tw-ring-color: rgb(11 30 138 / 0.3);
}
.focus\\:ring-orange-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-pink-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 207 232 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled{
  opacity: 0.7;
}
.group:hover .group-hover\\:text-brand-royal{
  --tw-text-opacity: 1;
  color: rgb(11 30 138 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:bottom-3{
    bottom: 0.75rem;
  }

  .sm\\:left-2{
    left: 0.5rem;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:right-2{
    right: 0.5rem;
  }

  .sm\\:right-3{
    right: 0.75rem;
  }

  .sm\\:right-4{
    right: 1rem;
  }

  .sm\\:top-3{
    top: 0.75rem;
  }

  .sm\\:top-4{
    top: 1rem;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .sm\\:ml-auto{
    margin-left: auto;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-10{
    margin-top: 2.5rem;
  }

  .sm\\:mt-3{
    margin-top: 0.75rem;
  }

  .sm\\:mt-4{
    margin-top: 1rem;
  }

  .sm\\:mt-6{
    margin-top: 1.5rem;
  }

  .sm\\:mt-8{
    margin-top: 2rem;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:grid{
    display: grid;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-1\\.5{
    height: 0.375rem;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-16{
    height: 4rem;
  }

  .sm\\:h-20{
    height: 5rem;
  }

  .sm\\:h-24{
    height: 6rem;
  }

  .sm\\:h-3\\.5{
    height: 0.875rem;
  }

  .sm\\:h-32{
    height: 8rem;
  }

  .sm\\:h-4{
    height: 1rem;
  }

  .sm\\:h-40{
    height: 10rem;
  }

  .sm\\:h-44{
    height: 11rem;
  }

  .sm\\:h-5{
    height: 1.25rem;
  }

  .sm\\:h-52{
    height: 13rem;
  }

  .sm\\:h-6{
    height: 1.5rem;
  }

  .sm\\:h-64{
    height: 16rem;
  }

  .sm\\:h-7{
    height: 1.75rem;
  }

  .sm\\:h-9{
    height: 2.25rem;
  }

  .sm\\:max-h-\\[80vh\\]{
    max-height: 80vh;
  }

  .sm\\:w-1\\.5{
    width: 0.375rem;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-12{
    width: 3rem;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-16{
    width: 4rem;
  }

  .sm\\:w-20{
    width: 5rem;
  }

  .sm\\:w-24{
    width: 6rem;
  }

  .sm\\:w-3\\.5{
    width: 0.875rem;
  }

  .sm\\:w-32{
    width: 8rem;
  }

  .sm\\:w-4{
    width: 1rem;
  }

  .sm\\:w-5{
    width: 1.25rem;
  }

  .sm\\:w-6{
    width: 1.5rem;
  }

  .sm\\:w-7{
    width: 1.75rem;
  }

  .sm\\:w-9{
    width: 2.25rem;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:min-w-48{
    min-width: 12rem;
  }

  .sm\\:max-w-\\[200px\\]{
    max-width: 200px;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xs{
    max-width: 20rem;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:gap-1{
    gap: 0.25rem;
  }

  .sm\\:gap-10{
    gap: 2.5rem;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-2xl{
    border-radius: 1rem;
  }

  .sm\\:rounded-3xl{
    border-radius: 1.5rem;
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .sm\\:p-2{
    padding: 0.5rem;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .sm\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-16{
    padding-bottom: 4rem;
  }

  .sm\\:pb-4{
    padding-bottom: 1rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-\\[180px\\]{
    font-size: 180px;
  }

  .sm\\:text-\\[200px\\]{
    font-size: 200px;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:static{
    position: static;
  }

  .md\\:absolute{
    position: absolute;
  }

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:mt-4{
    margin-top: 1rem;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:aspect-\\[16\\/8\\]{
    aspect-ratio: 16/8;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:max-w-md{
    max-width: 28rem;
  }

  .md\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:gap-5{
    gap: 1.25rem;
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .md\\:text-start{
    text-align: start;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:mb-8{
    margin-bottom: 2rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:aspect-\\[16\\/6\\]{
    aspect-ratio: 16/6;
  }

  .lg\\:w-\\[46\\%\\]{
    width: 46%;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:object-cover{
    object-fit: cover;
  }

  .lg\\:p-2{
    padding: 0.5rem;
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\.lucide-x\\]\\:text-white .lucide-x{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;QAAA,uBAAc;QAAd,yBAAc;QAAd,iBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,iCAAc;QAAd,sBAAc;QAAd,+BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,mBAAc;QAAd,8BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,oBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,iBAAc;IAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,wCAAc;EAAd;AAAc;;AAAd,iBAAA,kDAAc,EAAA;;AAAd,gBAAA,kDAAc,EAAd,uBAAc,EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,OAAO,uBAAuB,EAAE;;AAEhC;IACI,SAAS;IACT,kDAAkD;IAClD,mCAAmC;IACnC,kCAAkC;IAClC,mBAAmB;IACnB,cAAc;AAClB;;AAuCA,iCAAiC;AACjC;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,2CAA2C;AAC/C;AACA;IACI;;;;yDAIqD;AACzD;AACA,eAAe,8CAA8C,EAAE;AAC/D,cAAc,qDAAqD,EAAE;AACrE;IACI,0EAA0E;IAC1E,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,6DAA6D;IAC7D,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,qDAAqD;AACzD;AACA;IACI,6DAA6D;IAC7D,WAAW;AACf;AACA,oBAAoB,2BAA2B,EAAE,qDAAqD,EAAE;;AAExG;IACI,4EAA4E;AAChF;AACA;IACI,2BAA2B;IAC3B,qDAAqD;AACzD;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,4BAA4B;IAC5B,gBAAgB;IAChB,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,YAAY,EAAE,OAAO,EAAE,QAAQ;IAC/B,WAAW;IACX,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,gBAAgB;IAChB,gFAAgF;AACpF;AACA;IACI,aAAa;IACb,cAAc;IACd,SAAS;IACT,wCAAwC;AAC5C;;AAEA,sBAAsB;AACtB,eAAe,mBAAmB,EAAE;AACpC;IACI,6DAA6D;IAC7D,WAAW;AACf;AACA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA,qDAAqD;AACrD;IACI,gCAAgC;IAChC,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,kDAAkD;IAClD,iCAAiC;IACjC,kCAAkC;AACtC;AACA,0BAA0B,iBAAiB,EAAE;;AAE7C,gEAAgE;AAChE,kCAAkC,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB,EAAE;AAC3G,YAAY,gBAAgB,EAAE;AAC9B,YAAY,iBAAiB,EAAE;AAC/B,YAAY,gBAAgB,EAAE;AAC9B,WAAW,eAAe,EAAE,gBAAgB,EAAE;AAC9C,uBAAuB,mBAAmB,EAAE,eAAe,EAAE;AAC7D,YAAY,qBAAqB,EAAE;AACnC,YAAY,wBAAwB,EAAE;AACtC,YAAY,eAAe,EAAE;AAC7B,gBAAgB,cAAc,EAAE;AAChC,YAAY,cAAc,EAAE;AAC5B,oBAAoB,8BAA8B,EAAE,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC7H,WAAW,cAAc,EAAE,0BAA0B,EAAE;AACvD,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC5G,eAAe,WAAW,EAAE,yBAAyB,EAAE;AACvD,uBAAuB,yBAAyB,EAAE,cAAc,EAAE;;AAElE,4DAA4D;AAC5D,cAAc,sBAAsB,EAAE;AACtC,qBAAqB,sBAAsB,EAAE;;AAE7C,iCAAiC;AACjC,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE,oBAAoB,EAAE;AACvE,kCAAkC,mBAAmB,EAAE;AACvD,IAAI,qBAAqB,EAAE,oCAAoC,EAAE;;AAEjE,8BAA8B,4BAA4B,EAAE;AAC5D;IACI,oBAAoB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,sBAAsB;IACxF,qBAAqB,EAAE,sBAAsB,EAAE,oBAAoB,EAAE,uBAAuB;IAC5F,mBAAmB,EAAE,gBAAgB,EAAE,YAAY;IACnD,0BAA0B,EAAE,2BAA2B,EAAE,yBAAyB,EAAE,4BAA4B;IAChH,0BAA0B,EAAE,2BAA2B,EAAE,yBAAyB,EAAE,4BAA4B;IAChH,0BAA0B,EAAE,2BAA2B,EAAE,yBAAyB,EAAE,4BAA4B;AACpH;AAxMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,mBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA,QAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA,sBAyMA;EAzMA;AAyMA;AAzMA;EAAA,iDAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kDAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,2BAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,iBAyMA;EAzMA,iBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,sBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,0CAyMA;EAzMA,uDAyMA;EAzMA;AAyMA;AAzMA;EAAA,sBAyMA;EAzMA;AAyMA;AAzMA;EAAA,sBAyMA;EAzMA;AAyMA;AAzMA;EAAA,sBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,8BAyMA;EAzMA;AAyMA;AAzMA;EAAA,2GAyMA;EAzMA,yGAyMA;EAzMA;AAyMA;AAzMA;EAAA,2GAyMA;EAzMA,yGAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,8BAyMA;EAzMA;AAyMA;AAzMA;EAAA,2GAyMA;EAzMA,yGAyMA;EAzMA;AAyMA;AAzMA;EAAA,2GAyMA;EAzMA,yGAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,+EAyMA;EAzMA,mGAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,yBAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,yBAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,sBAyMA;EAzMA;AAyMA;AAzMA;EAAA,qBAyMA;EAzMA;AAyMA;AAzMA;EAAA,qBAyMA;EAzMA;AAyMA;AAzMA;EAAA,gDAyMA;EAzMA;AAyMA;AAzMA;EAAA,iDAyMA;EAzMA;AAyMA;AAzMA;;EAAA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;AAAA;AAzMA;EAAA;AAyMA;AAzMA;;EAAA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;AAAA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,0EAyMA;EAzMA,8FAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,qBAyMA;EAzMA,yBAyMA;EAzMA,2BAyMA;EAzMA,yBAyMA;EAzMA,0BAyMA;EAzMA,+BAyMA;EAzMA;AAyMA;AAzMA;EAAA,qBAyMA;EAzMA,yBAyMA;EAzMA,2BAyMA;EAzMA,yBAyMA;EAzMA,0BAyMA;EAzMA,+BAyMA;EAzMA;AAyMA;AAzMA;EAAA,qBAyMA;EAzMA,yBAyMA;EAzMA,2BAyMA;EAzMA,yBAyMA;EAzMA,0BAyMA;EAzMA,+BAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA,yBAyMA;EAzMA,0BAyMA;EAzMA,wBAyMA;EAzMA,yBAyMA;EAzMA,8BAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA,yBAyMA;EAzMA,0BAyMA;EAzMA,wBAyMA;EAzMA,yBAyMA;EAzMA,8BAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA,yBAyMA;EAzMA,0BAyMA;EAzMA,wBAyMA;EAzMA,yBAyMA;EAzMA,8BAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA,yBAyMA;EAzMA,0BAyMA;EAzMA,wBAyMA;EAzMA,yBAyMA;EAzMA,8BAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA,sBAyMA;EAzMA;AAyMA;AAzMA;EAAA,0BAyMA;EAzMA,qBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,mBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;;EAAA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,gBAyMA;IAzMA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,uBAyMA;IAzMA,sDAyMA;IAzMA;EAyMA;;EAzMA;IAAA,uBAyMA;IAzMA,oDAyMA;IAzMA;EAyMA;;EAzMA;IAAA,uBAyMA;IAzMA,2DAyMA;IAzMA;EAyMA;;EAzMA;IAAA,uBAyMA;IAzMA,+DAyMA;IAzMA;EAyMA;;EAzMA;IAAA,uBAyMA;IAzMA,4DAyMA;IAzMA;EAyMA;;EAzMA;IAAA,uBAyMA;IAzMA,+DAyMA;IAzMA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,oBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,qBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,kBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,qBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,oBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,qBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,iBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,mBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,mBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,qBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,oBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,iBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,iBAyMA;IAzMA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,iBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,kBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,eAyMA;IAzMA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,eAyMA;IAzMA;EAyMA;;EAzMA;IAAA,mBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,mBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,kBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,kBAyMA;IAzMA;EAyMA;;EAzMA;IAAA;EAyMA;AAAA;AAzMA;;EAAA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,qBAyMA;IAzMA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,qBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,iBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,oBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,iBAyMA;IAzMA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,mBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,kBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,eAyMA;IAzMA;EAyMA;;EAzMA;IAAA,mBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,mBAyMA;IAzMA;EAyMA;AAAA;AAzMA;;EAAA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA;EAyMA;;EAzMA;IAAA,kBAyMA;IAzMA;EAyMA;;EAzMA;IAAA,iBAyMA;IAzMA;EAyMA;;EAzMA;IAAA;EAyMA;AAAA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kDAyMA;EAzMA;AAyMA;AAzMA;EAAA,iDAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,iDAyMA;EAzMA;AAyMA;AAzMA;EAAA,kDAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kDAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,qBAyMA;EAzMA;AAyMA;AAzMA;EAAA,gBAyMA;EAzMA,oBAyMA;EAzMA,4BAyMA;EAzMA;AAyMA;AAzMA;EAAA,sBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,WAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA,mBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,qBAyMA;EAzMA;AAyMA;AAzMA;EAAA,kBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA,oBAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA,WAyMA;EAzMA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA;AAzMA;EAAA;AAyMA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300;400;500;600;700&family=Outfit:wght@300;400;500;600;700;800&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml { scroll-behavior: smooth; }\n\nbody {\n    margin: 0;\n    font-family: \"Hind Siliguri\", \"Outfit\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background: #ffffff;\n    color: #08145A;\n}\n\n@layer base {\n    :root {\n        --background: 0 0% 100%;\n        --foreground: 230 67% 19%;\n        --card: 0 0% 100%;\n        --card-foreground: 230 67% 19%;\n        --popover: 0 0% 100%;\n        --popover-foreground: 230 67% 19%;\n        --primary: 232 86% 29%;\n        --primary-foreground: 0 0% 100%;\n        --secondary: 209 30% 90%;\n        --secondary-foreground: 230 67% 19%;\n        --muted: 210 40% 96%;\n        --muted-foreground: 215 20% 45%;\n        --accent: 0 75% 48%;\n        --accent-foreground: 0 0% 100%;\n        --destructive: 0 75% 48%;\n        --destructive-foreground: 0 0% 100%;\n        --border: 214 32% 91%;\n        --input: 214 32% 91%;\n        --ring: 232 86% 29%;\n        --chart-1: 232 86% 29%;\n        --chart-2: 209 30% 65%;\n        --chart-3: 0 75% 48%;\n        --chart-4: 230 67% 19%;\n        --chart-5: 209 30% 85%;\n        --radius: 0.85rem;\n    }\n}\n\n@layer base {\n    * { @apply border-border; }\n    body { @apply bg-background text-foreground; }\n    h1,h2,h3,h4,h5 { font-family: \"Hind Siliguri\", \"Outfit\", sans-serif; }\n    .font-display { font-family: \"Outfit\", \"Hind Siliguri\", sans-serif; letter-spacing: -0.02em; }\n}\n\n/* ===== Custom utilities ===== */\n.glass {\n    background: rgba(255, 255, 255, 0.72);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.6);\n    box-shadow: 0 8px 32px rgba(11, 30, 138, 0.06);\n}\n.glass-dark {\n    background: rgba(8, 20, 90, 0.72);\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n.bg-hero-grad {\n    background:\n        radial-gradient(circle at 8% 18%, rgba(220, 231, 241, 0.9), transparent 55%),\n        radial-gradient(circle at 92% 12%, rgba(175, 196, 214, 0.55), transparent 55%),\n        radial-gradient(circle at 50% 90%, rgba(11, 30, 138, 0.12), transparent 60%),\n        linear-gradient(135deg, #ffffff 0%, #DCE7F1 100%);\n}\n.shadow-soft { box-shadow: 0 4px 20px rgba(11, 30, 138, 0.08); }\n.shadow-pop { box-shadow: 0 18px 50px -12px rgba(11, 30, 138, 0.28); }\n.gradient-text-blue {\n    background: linear-gradient(135deg, #0B1E8A 0%, #08145A 50%, #0B1E8A 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n}\n.btn-primary {\n    background: linear-gradient(135deg, #0B1E8A 0%, #08145A 100%);\n    color: #fff;\n    transition: all 0.3s ease;\n}\n.btn-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 16px 32px -10px rgba(11, 30, 138, 0.55);\n}\n.btn-accent {\n    background: linear-gradient(135deg, #D61F1F 0%, #A41616 100%);\n    color: #fff;\n}\n.btn-accent:hover { transform: translateY(-2px); box-shadow: 0 14px 30px -10px rgba(214, 31, 31, 0.55); }\n\n.book-card {\n    transition: transform 0.4s cubic-bezier(.21,.61,.35,1), box-shadow 0.4s ease;\n}\n.book-card:hover {\n    transform: translateY(-8px);\n    box-shadow: 0 24px 48px -16px rgba(11, 30, 138, 0.25);\n}\n\n/* Math symbols floating background */\n.math-symbol {\n    position: absolute;\n    color: rgba(11, 30, 138, 0.06);\n    font-family: \"Outfit\", serif;\n    font-weight: 700;\n    pointer-events: none;\n    user-select: none;\n}\n\n/* hero curved separator */\n.curve-bottom {\n    position: absolute;\n    bottom: -1px; left: 0; right: 0;\n    width: 100%;\n    height: 80px;\n}\n\n/* Marquee track */\n.marquee {\n    display: flex;\n    overflow: hidden;\n    mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);\n}\n.marquee-track {\n    display: flex;\n    flex-shrink: 0;\n    gap: 3rem;\n    animation: marquee-x 35s linear infinite;\n}\n\n/* Sidebar for admin */\n.admin-shell { background: #F1F5F9; }\n.admin-side {\n    background: linear-gradient(180deg, #08145A 0%, #0B1E8A 100%);\n    color: #fff;\n}\n.admin-side a.active, .admin-side button.active {\n    background: rgba(255, 255, 255, 0.15);\n    border-left: 3px solid #D61F1F;\n}\n\n/* ===== React Quill (admin editor) overrides ===== */\n.rich-editor .ql-toolbar {\n    border-color: #E2E8F0 !important;\n    background: #F8FAFC;\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n}\n.rich-editor .ql-container {\n    border-color: #E2E8F0 !important;\n    min-height: 140px;\n    font-family: \"Hind Siliguri\", \"Outfit\", sans-serif;\n    border-bottom-left-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n}\n.rich-editor .ql-editor { min-height: 140px; }\n\n/* ===== Prose styling for rendered HTML on book details ===== */\n.prose h1, .prose h2, .prose h3 { color: #08145A; font-weight: 700; margin-top: 1em; margin-bottom: 0.5em; }\n.prose h1 { font-size: 1.5em; }\n.prose h2 { font-size: 1.25em; }\n.prose h3 { font-size: 1.1em; }\n.prose p { margin: 0.5em 0; line-height: 1.7; }\n.prose ul, .prose ol { padding-left: 1.5em; margin: 0.5em 0; }\n.prose ul { list-style-type: disc; }\n.prose ol { list-style-type: decimal; }\n.prose li { margin: 0.2em 0; }\n.prose strong { color: #08145A; }\n.prose em { color: #0B1E8A; }\n.prose blockquote { border-left: 3px solid #0B1E8A; padding-left: 1em; color: #475569; font-style: italic; margin: 0.75em 0; }\n.prose a { color: #0B1E8A; text-decoration: underline; }\n.prose code, .prose pre { background: #F1F5F9; padding: 0.15em 0.4em; border-radius: 4px; font-size: 0.9em; }\n.prose table { width: 100%; border-collapse: collapse; }\n.prose td, .prose th { border: 1px solid #E2E8F0; padding: 0.5em; }\n\n/* Quill toolbar inside Shadcn Dialog needs higher z-index */\n.ql-tooltip { z-index: 60 !important; }\n.ql-picker-options { z-index: 60 !important; }\n\n/* ===== Custom scrollbar ===== */\n::-webkit-scrollbar { width: 4px; height: 4px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: #CBD5E1; border-radius: 999px; }\n::-webkit-scrollbar-thumb:hover { background: #94A3B8; }\n* { scrollbar-width: thin; scrollbar-color: #CBD5E1 transparent; }\n\n[data-debug-wrapper=\"true\"] { display: contents !important; }\n[data-debug-wrapper=\"true\"] > * {\n    margin-left: inherit; margin-right: inherit; margin-top: inherit; margin-bottom: inherit;\n    padding-left: inherit; padding-right: inherit; padding-top: inherit; padding-bottom: inherit;\n    column-gap: inherit; row-gap: inherit; gap: inherit;\n    border-left-width: inherit; border-right-width: inherit; border-top-width: inherit; border-bottom-width: inherit;\n    border-left-style: inherit; border-right-style: inherit; border-top-style: inherit; border-bottom-style: inherit;\n    border-left-color: inherit; border-right-color: inherit; border-top-color: inherit; border-bottom-color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
